.actions {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-top: 8px;
}

/* The main button takes the rest of the row. */
.row {
  display: flex;
  gap: 10px;
}

.row > button:last-child {
  flex: 1 1 auto;
}

.back {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 52px;
  height: 52px;
  padding: 0;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--surface);
  color: var(--ink);
  cursor: pointer;
}

.back:disabled {
  border-color: var(--line);
  color: var(--ink-3);
  cursor: default;
}

/* The arrow is a mask painted in currentColor, so it follows the button. */
.arrow {
  width: 20px;
  height: 20px;
  background-color: currentColor;
  -webkit-mask: url('./back.svg') no-repeat center / contain;
  mask: url('./back.svg') no-repeat center / contain;
}

.skipRow {
  display: flex;
  justify-content: flex-end;
}

.skip {
  min-height: 44px;
  padding: 0 4px;
  border: 0;
  background: none;
  font-weight: 700;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}
